import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { AlertView } from '../../features/alerts/components/AlertView';
// eslint-disable-next-line no-restricted-imports
import { InboxNotificationView } from '../../features/inbox/components/InboxNotificationView/InboxNotificationView';
export function showAlertNotificationRowDialog(props) {
    const ViewComponent = props.type === 'alert' ? AlertView : InboxNotificationView;
    return showCustomDialog({
        fullScreen: true,
        content: (close, ariaLabelledBy) => (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.grey[900],
                    color: (theme) => theme.palette.background.paper,
                    display: 'flex',
                    justifyContent: 'space-between',
                    py: 2,
                } },
                React.createElement(Button, { variant: 'text', color: 'inherit', size: 'large', onClick: () => {
                        close();
                        props.onClearActiveRow();
                    }, sx: { pl: 2, gap: 1 }, "data-test": 'back-to-list-button' },
                    React.createElement(ArrowBackIcon, { fontSize: 'small' }),
                    React.createElement(Typography, { id: ariaLabelledBy, variant: 'h6', sx: { fontSize: '14px' } }, props.label))),
            props.rowId && (React.createElement(ViewComponent, { id: props.rowId, onReload: (clearActiveAlert) => {
                    if (clearActiveAlert) {
                        props.onClearActiveRow();
                    }
                    props.onReload();
                }, onCloseDialog: close })))),
    });
}
